import AdjustmentInBatchPage from './AdjustmentInBatchPage'

export default AdjustmentInBatchPage
